import { decodeURLSearchParamsParam, encodeObjectToURLSearchParams, } from '@dossierhq/core';
import { useEffect } from 'react';
import { getQueryWithoutDefaults, initializeSearchEntityState, SearchEntityStateActions, } from './SearchEntityReducer.js';
export function initializeSearchEntityStateFromUrlQuery({ mode, urlSearchParams, }) {
    const actions = urlQueryToSearchEntityStateActions(urlSearchParams);
    return initializeSearchEntityState({ mode, actions });
}
function urlQueryToSearchEntityStateActions(urlSearchParams) {
    const actions = [];
    if (urlSearchParams) {
        const query = decodeURLSearchParamsParam(urlSearchParams, 'query');
        const sampling = decodeURLSearchParamsParam(urlSearchParams, 'sampling');
        const paging = decodeURLSearchParamsParam(urlSearchParams, 'paging');
        actions.push(new SearchEntityStateActions.SetQuery(query ?? {}, {
            partial: false,
            resetPagingIfModifying: false,
        }));
        if (sampling) {
            actions.push(new SearchEntityStateActions.SetSampling(sampling, false));
        }
        if (paging || !sampling) {
            actions.push(new SearchEntityStateActions.SetPaging(paging ?? {}));
        }
    }
    return actions;
}
export function useSynchronizeUrlQueryAndSearchEntityState(mode, urlSearchParams, onUrlSearchParamsChange, searchEntityState, dispatchSearchEntityState) {
    const { query, paging, sampling } = searchEntityState;
    useEffect(() => {
        if (!onUrlSearchParamsChange || !urlSearchParams)
            return;
        const params = {
            query: getQueryWithoutDefaults(mode, query),
            paging,
            sampling,
        };
        const result = encodeObjectToURLSearchParams(params);
        if (urlSearchParams.toString() !== result.toString()) {
            onUrlSearchParamsChange(result);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query, paging, sampling]);
    useEffect(() => {
        if (!urlSearchParams)
            return;
        const actions = urlQueryToSearchEntityStateActions(urlSearchParams);
        actions.forEach((action) => dispatchSearchEntityState(action));
    }, [dispatchSearchEntityState, urlSearchParams]);
    // useDebugLogChangedValues('useSynchronizeUrlQueryState', { query, paging, sampling, sample, urlQuery });
}
//# sourceMappingURL=SearchEntityUrlSynchronizer.js.map